import { ReactNode } from 'react'
import { Header } from './header'

interface MainLayoutProps {
  children: ReactNode
}

/**
 * Main layout component that wraps the entire application
 * Provides consistent header and main content area structure
 * Implements responsive design with proper container spacing
 */
export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="h-dvh bg-background text-foreground flex flex-col overflow-hidden">
      {/* Header */}
      <Header />

      {/* Main content area - scrollable */}
      <main id="main-scroll-container" className="flex-1 overflow-y-auto">
        {children}
      </main>
    </div>
  )
}
